import React from 'react';
import PropTypes from 'prop-types';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { VisitorEntities } from 'client/data/models/visitor';
import { FeaturesSpecsParams } from 'site-modules/shared/utils/features-specs/params';
import { LEAD_FORMS_CREATIVE_ID } from 'site-modules/shared/components/lead-form/unified-lead-form/constants/creative-ids';
import { getLeadFormCreativeId } from 'site-modules/shared/components/lead-form/utils/lead-form-creative-id';
import { FeaturesSpecsCta } from 'site-modules/features-specs/components/features-specs-cta/features-specs-cta';
import { InventoryButton } from 'site-modules/shared/components/inventory-button/inventory-button';

export function InventorySection({ params, vehicle, visitorLocation, styleId, trimName, pageName }) {
  return params.isUsed ? (
    <div className="d-flex">
      <InventoryButton
        className="rounded-8"
        params={params}
        makeModelSubmodelYear={vehicle}
        visitorLocation={visitorLocation}
      />
      <InventoryButton
        className="rounded-8"
        params={params}
        makeModelSubmodelYear={vehicle}
        visitorLocation={visitorLocation}
        isBuyOnline
      />
    </div>
  ) : (
    <FeaturesSpecsCta
      vehicle={vehicle}
      styleId={styleId}
      trimName={trimName}
      leadFormCreativeId={getLeadFormCreativeId({
        isNewVin: true,
        pageNameLegacy: pageName,
        formName: LEAD_FORMS_CREATIVE_ID.FEATURE_SPECS,
      })}
      dataTrackingParent="features-specs-cta2"
    />
  );
}

InventorySection.propTypes = {
  params: FeaturesSpecsParams.isRequired,
  vehicle: VehicleEntities.MakeModelSubmodelYear.isRequired,
  styleId: PropTypes.number.isRequired,
  visitorLocation: VisitorEntities.Location,
  trimName: PropTypes.string,
  pageName: PropTypes.string,
};

InventorySection.defaultProps = {
  visitorLocation: null,
  trimName: null,
  pageName: null,
};
